export const SET_CONTRACTS = 'SET_CONTRACTS';
export const SET_CONTRACTS_IS_LOADING = 'SET_CONTRACTS_IS_LOADING';
export const SET_SELECTED_CONTRACT = 'SET_SELECTED_CONTRACT';
export const SET_SELECTED_CONTRACT_LOADING = 'SET_SELECTED_CONTRACT_LOADING';
export const UPDATE_ASSET_DOWNLOAD_STATUS = 'UPDATE_ASSET_DOWNLOAD_STATUS';
export const UPDATE_ASSET_TRANSFER_STATUS = 'UPDATE_ASSET_TRANSFER_STATUS';
export const UPDATE_TRANSFER_PROCESS_CONFIG = 'UPDATE_TRANSFER_PROCESS_CONFIG';
export const RESET_TRANSFER_PROCESS_CONFIG = 'RESET_TRANSFER_PROCESS_CONFIG';
